import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

const SUB_COMPANIES_ROUTING_PATHS = {
  subCompanyId: 'subCompanyId',
  tab: 'tab',
  entityId: 'entityId',
};

export class SubCompaniesPaths {
  static subCompanies = new EnhancedPath('/sub-companies');

  // The optional `:entityId?` is tab-scoped (mirrors the loan editor's entityId slot):
  // an AI-process execution id under AI Activity, the active sub-tab under Setup, and
  // the open edit-drawer section under Overview (general). Other tabs omit it; the tab
  // is always present when entityId is, so the empty-intermediate-optional drop that
  // bit the loan path (DEV-3029) can't occur.
  static subCompany = new EnhancedPath(
    `${SubCompaniesPaths.subCompanies.path}/:${SUB_COMPANIES_ROUTING_PATHS.subCompanyId}/:${SUB_COMPANIES_ROUTING_PATHS.tab}?/:${SUB_COMPANIES_ROUTING_PATHS.entityId}?`,
  );
}

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: SubCompaniesPaths.subCompany.path,
      component: lazyWithRetry(() => import('app/pages/subCompanies/SubCompanyPage')),
      pageCode: PAGE_CODES.SUB_COMPANIES,
    },
  ],
};

export default routesConfig;
